import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { format, parse, startOfWeek, getDay } from "date-fns";
import CustomToolbar from "./CustomToolbar";
import CustomEvent from "./CustomEvent";
import { es } from "date-fns/locale";

const locales = { es };
const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek: () => startOfWeek(new Date(), { weekStartsOn: 1 }),
  getDay,
  locales,
});

const capitalize = (text) => text.charAt(0).toUpperCase() + text.slice(1);

const CalendarComponent = ({ events, view, onViewChange, onSelectEvent }) => {

  return (
    <Calendar
      className="agenda"
      localizer={localizer}
      culture="es"
      events={events}
      startAccessor="start"
      endAccessor="end"
      style={{ height: 750 }}
      view={view}
      views={["month", "week", "day", "agenda"]}
      onView={onViewChange}
      onSelectEvent={onSelectEvent}
      components={{ toolbar: CustomToolbar, event: CustomEvent }}
      step={60}
      showMultiDayTimes
      defaultDate={new Date()}
      messages={{
        today: "Hoy",
        previous: "Anterior",
        next: "Siguiente",
        month: "Mes",
        week: "Semana",
        day: "Día",
        agenda: "Agenda",
        date: "Fecha",
        time: "Hora",
        event: "Asunto y usuario",
        noEventsInRange: "No hay eventos en este rango.",
      }}
      formats={{
        dayFormat: (date, culture, localizer) =>
          capitalize(localizer.format(date, "EEEE", culture)), // Lunes, Martes...

        weekdayFormat: (date, culture, localizer) =>
          capitalize(localizer.format(date, "EEEE", culture)), // Lunes en vista mensual

        monthHeaderFormat: (date, culture, localizer) =>
          capitalize(localizer.format(date, "MMMM yyyy", culture)), // Marzo 2025

        headerFormat: ({ start, end }, culture, localizer) => {
          const formattedStart = localizer.format(start, "d", culture);
          const formattedEnd = localizer.format(end, "d 'de' MMMM", culture);
          return `Del ${formattedStart} al ${formattedEnd}`;
        },

        dayRangeHeaderFormat: ({ start, end }, culture, localizer) => {
          const formattedStart = localizer.format(start, "d", culture);
          const formattedEnd = localizer.format(end, "d 'de' MMMM", culture);
          return `Del ${formattedStart} al ${formattedEnd}`;
        },

        dayHeaderFormat: (date, culture, localizer) =>
          capitalize(localizer.format(date, "EEEE d 'de' MMMM", culture)), // Miércoles 2 de abril

        agendaDateFormat: (date, culture, localizer) =>
          capitalize(localizer.format(date, "EEEE d MMMM", culture)), // Miércoles 26 de marzo
      }}
    />
  );
};

export default CalendarComponent;
